import crypto from 'crypto'
import { getOrCreateHeadlessPool } from '@things-factory/shell'

const { Readable } = require('stream')
const ejs = require('ejs')

export const pdfToImage = async ({ pdfPath, fileName, extension = 'png', quality = 2, defaultViewport = null }) => {
  // Use headless pool instead of direct puppeteer.launch
  const pool = getOrCreateHeadlessPool('board-pdf', {
    min: 1,
    max: 3,
    args: [
      '--disable-web-security',
      '--disable-features=IsolateOrigins', 
      '--disable-site-isolation-trials',
      '--no-sandbox'
    ]
  })

  const browser = await pool.acquire()

  try {
    const protocol = 'http'
    const host = 'localhost'
    const port = process.env.PORT
    const pdfUrl = `${protocol}://${host}:${port}${pdfPath}`

    const page = await browser.newPage()
    const html = await ejs.render(getPdfHtmlTemplate(), {
      data: { pdfUrl, quality },
      nonce: crypto.randomBytes(16).toString('hex')
    })

    // setContent 의 waitUntil 은 'load'/'domcontentloaded' 만 지원 → API/fetch 응답
    // 정착은 waitForNetworkIdle 로 별도 대기.
    await page.setContent(html, { waitUntil: 'load' })
    await page.waitForNetworkIdle()
    await page.$('#page')
    const screenshot = await page.screenshot({
      type: extension,
      omitBackground: true
    })

    // graphql fileupload형태로 return을 위해 stream 생성
    const stream = new Readable()
    stream.push(screenshot)
    stream.push(null)

    await pool.release(browser)

    // file upload 형태로 return
    return {
      filename: `${fileName}.${extension}`,
      mimetype: `image/${extension}`,
      encoding: '7bit',
      createReadStream: () => stream
    }
  } catch (e) {
    await pool.release(browser)
    console.error('Error creating thumbnail', e)
    throw new Error('Error creating thumbnail')
  }
}

function getPdfHtmlTemplate() {
  return `
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />

        <style nonce="<%= nonce %>">
          body {
            width: 100vw;
            height: 100vh;
            margin: 0;
          }
          #page {
            display: flex;
            width: 100%;
            height: 100%;
          }
        </style>

      </head>
      <body>
        <canvas id="page"></canvas>
        <script src="https://unpkg.com/pdfjs-dist@2.0.489/build/pdf.min.js"></script>
        <script nonce="<%= nonce %>">
          ;(async () => {
            const pdf = await pdfjsLib.getDocument('<%= data.pdfUrl %>')
            const page = await pdf.getPage(1)
            const viewport = page.getViewport('<%= data.quality %>')
            const canvas = document.getElementById('page')
            const context = canvas.getContext('2d')

            canvas.height = viewport.height
            canvas.width = viewport.width

            const renderContext = {
              canvasContext: context,
              viewport: viewport
            }

            page.render(renderContext)
          })()
        </script>
      </body>
    </html>
  `
}
